import { createUserModel } from '@/core/shared/auth/store/models';
import { createOrganizationModel } from '@/core/shared/vuex-modules/organization';
import { createLocaleModel } from '@/core/shared/vuex-modules/locale';
import AudioService from '@/core/AudioService';
import store from '../store';
import moment from 'moment-timezone';

export default schema => {
  const User = createUserModel(schema);
  const Organization = createOrganizationModel(schema);
  const Locale = createLocaleModel(schema);

  const Location = new schema.Entity('Location');
  const Experience = new schema.Entity('Experience');
  const Station = new schema.Entity('Station', {}, {
    processStrategy (station) {
      (station.calling) ? AudioService.startCalling() : AudioService.stopCalling();
      return { ...station };
    },
  });
  const Booking = new schema.Entity('Booking');
  const StationTemporaryClosing = new schema.Entity('StationTemporaryClosing');
  const BookingStationTime = new schema.Entity('BookingStationTime', {
    station: Station,
    experience: Experience,
  }, {
    // This whole thing is to address the fact that some bookingStationTimes have a 'null' tier. The null tier means that it's a custom tier and must be
    // calculated on the fly. This is slightly more complicated than I intended, but it's worth it, considering how easy it is to use tiers now in components
    processStrategy (bookingStationTimeDelta, parent) {
      const bookingStationTime = { ...bookingStationTimeDelta };

      if (bookingStationTime.tier === null) {
        const bookingStationTimes = store.getters['entities/BookingStationTime'](parent.bookingStationTimes.filter(id => id === bookingStationTime.id));

        const paid = bookingStationTimes.reduce((price, existingBookingStationTime) => {
          return existingBookingStationTime.amountDue + price;
        }, 0) === 0;

        bookingStationTime.tier = {
          id: 'custom',
          length: Math.round(moment(bookingStationTime.endTime).diff(parent.startTime) / 1000 / 60),
          price: (paid) ? bookingStationTime.amountPaid : bookingStationTime.amountDue,
        };
      }

      return bookingStationTime;
    },
  });

  const Content = new schema.Entity('Content');

  Booking.define({
    location: Location,
    bookingStationTimes: [BookingStationTime],
  });

  StationTemporaryClosing.define({
    location: Location,
    station: Station,
  });

  User.define({
    organization: Organization,
  });

  return {
    User,
    Organization,
    Locale,
    Booking,
    StationTemporaryClosing,
    Station,
    Location,
    Experience,
    BookingStationTime,
    Content,
  };
};
